import {faCircleInfo} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Progress, Space, Tooltip, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {MetricDelta} from '../../metric-delta';

import {SCORE_MAX} from './brand-analysis-const';
import * as styles from './metric-card.scss';

type PropsType = {
    labelKey: LangKeyType;
    tooltip: string;
    score: number | null | undefined;
    delta: number | null | undefined;
    note: string;
    color: string;
};

// One headline score (visibility or tonality) with its progress bar and change vs. the previous run.
export function MetricCard(props: PropsType): JSX.Element {
    const {labelKey, tooltip, score, delta, note, color} = props;
    const value = score ?? 0;

    return (
        <div className={styles.metric_card}>
            <Space align="center" className={styles.metric_card__label} size="small">
                <Typography.Text type="secondary">
                    <Locale stringKey={labelKey} />
                </Typography.Text>
                <Tooltip title={tooltip}>
                    <FontAwesomeIcon className={styles.metric_card__info_icon} icon={faCircleInfo} />
                </Tooltip>
            </Space>

            <div className={styles.metric_card__score}>
                <span className={styles.metric_card__score_value}>{value}</span>
                <span className={styles.metric_card__score_max}>{`/ ${SCORE_MAX}`}</span>
                <MetricDelta delta={delta} />
            </div>

            <Progress
                className={styles.metric_card__progress}
                percent={value}
                showInfo={false}
                size="small"
                strokeColor={color}
            />

            <Typography.Text className={styles.metric_card__note} type="secondary">
                {note}
            </Typography.Text>
        </div>
    );
}
